import { render, staticRenderFns } from "./PortalArticleList.vue?vue&type=template&id=f774fdbc&"
import script from "./PortalArticleList.vue?vue&type=script&lang=js&"
export * from "./PortalArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports